<template>
  <div class="SlideHeading">
    <div v-if="content.label" class="label">{{ content.label }}</div>
    <h3 v-if="content.title" class="title">{{ content.title }}</h3>
    <p v-if="content.subtitle" class="subtitle">{{ content.subtitle }}</p>
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
  },
}
</script>

<style scoped>

.label {
  font-weight: 600;
  font-size: var(--font-size-3);
  line-height: 1.5;
  color: var(--brand-color);
}

.title {
  font-weight: 700;
  font-size: var(--font-size-8);
  line-height: 1.25;
  color: var(--text-color-white);
}

.subtitle {
  margin-top: var(--spacing-3);
  font-weight: 600;
  font-size: var(--font-size-4);
  line-height: 1.35;
  color: var(--text-color-white);
}
</style>
